<template>
  <div v-if="messageType" class='message' :class="messageTypeClass">{{ message }}</div>
</template>

<script>
  import Vue from 'vue';

  export default Vue.component('Message', {
    props: {
      messageType: String, // error|success
      message: String,
    },
    methods: {
      // not used
      friendlyErrorMessage: () => 'The site is currently down and will be fixed as soon as possible. Please check back in a few minutes.'
    },
    computed: {
      messageTypeClass: function() {
        if (this.messageType) {
          return `message--${this.messageType}`
        }
        return null;
      }
    }
  });
</script>